import React from 'react';
import {PiUsersThreeLight} from "react-icons/pi";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import useVisitors from "../../../hooks/public/useVisitors";

const VisitorCounter = () => {
    const {data} = useVisitors();

    return (
        <section className="visitor-count-section">
            <div className="custom-container">
                <header className="visitor-count-header">
                    <h1 className="visitor-count-section-title">Visitor Statistics</h1>
                </header>
                <div className="visitor-count-body">
                    <div className='row'>
                        {data?.map(({title, count}, index) => (
                            <div className='col-md-6 col-xl-3' key={index}>
                                <div className="counter-card">
                                    <div className='content-container'>
                                        <PiUsersThreeLight size={80} color='rgb(146 210 223)'/>
                                        <div className='ml-4'>
                                            <CountUp end={count} redraw={true}>
                                                {({countUpRef, start}) => (
                                                    <VisibilitySensor onChange={start} delayedCall>
                                                        <span className='count' ref={countUpRef}/>
                                                    </VisibilitySensor>
                                                )}
                                            </CountUp>
                                            <h3>{title}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisitorCounter;
